/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * request body of POST /media_list/prtimes_media_lists
 * @export
 * @interface CreateMediaListRequest
 */
export interface CreateMediaListRequest {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof CreateMediaListRequest
     */
    mediaListName: string;
    /**
     * 送信者名
     * @type {string}
     * @memberof CreateMediaListRequest
     */
    senderName: string;
    /**
     * 追加するメディアのIDリスト
     * @type {Array<number>}
     * @memberof CreateMediaListRequest
     */
    mediaOutletIds: Array<number>;
}

export function CreateMediaListRequestFromJSON(json: any): CreateMediaListRequest {
    return CreateMediaListRequestFromJSONTyped(json, false);
}

export function CreateMediaListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMediaListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': json['media_list_name'],
        'senderName': json['sender_name'],
        'mediaOutletIds': json['media_outlet_ids'],
    };
}

export function CreateMediaListRequestToJSON(value?: CreateMediaListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
        'media_outlet_ids': value.mediaOutletIds,
    };
}

